// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.match-cost-detail[data-v-48018eca] {
  height: 400px;
}
.match-cost-detail .table[data-v-48018eca] {
  height: calc(100% - 72px);
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/DataAnalysis/MatchCostDetail.vue","webpack://./MatchCostDetail.vue"],"names":[],"mappings":"AACA;EACE,aAAA;ACAF;ADDA;EAGI,yBAAA;ACCJ","sourcesContent":["\n.match-cost-detail {\n  height: 400px;\n  .table {\n    height: calc(100% - 72px);\n  }\n}\n",".match-cost-detail {\n  height: 400px;\n}\n.match-cost-detail .table {\n  height: calc(100% - 72px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
